export const BGCircleLoading = ({ className = "w-6 h-6" }: { className?: string }) => {
	return <div className={`${className} border-4 border-t-orange-500 border-orange-100 rounded-full animate-spin`} />;
};
